import React, { useEffect, useState } from 'react';

let pushToastImpl = null;

export function showToast(message, type = 'info') {
  if (pushToastImpl) {
    const id = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    pushToastImpl({ id, message, type });
  }
}

export function installGlobalToast(){
  window.showToast = showToast;
}

export default function ToastContainer(){
  const [toasts, setToasts] = useState([]);

  useEffect(()=>{
    pushToastImpl = (t) => {
      setToasts(prev => [...prev, t]);
      // Auto-dismiss after 5 seconds (reduced from 30)
      setTimeout(() => dismiss(t.id), 5000);
    };
    return ()=>{ pushToastImpl = null; };
  },[]);

  const dismiss = (id) => setToasts(prev => prev.filter(t => t.id !== id));

  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 flex flex-col gap-2 pointer-events-none w-full px-4" style={{maxWidth: '400px'}}>
      {toasts.map(t => (
        <div 
          key={t.id} 
          className="pointer-events-auto animate-slide-in"
          style={{
            borderRadius:12,
            padding:'16px 20px',
            color:'#fff',
            boxShadow:'0 8px 24px rgba(0,0,0,0.25)',
            backgroundColor: t.type==='success' ? '#22c55e' : t.type==='error' ? '#ef4444' : t.type==='info' ? '#3b82f6' : '#333',
          }}
        >
          <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', gap:12}}>
            <div style={{fontWeight:600, fontSize:16}}>
              {t.type==='success'?'✅ Success':t.type==='error'?'❌ Error':t.type==='info'?'ℹ️ Notice':'📢 Notice'}
            </div>
            <button 
              onClick={()=>dismiss(t.id)} 
              className="bg-transparent border-none text-white cursor-pointer text-xl leading-none p-0 w-6 h-6 flex items-center justify-center hover:opacity-80"
            >
              ×
            </button>
          </div>
          <div style={{marginTop:8, lineHeight:1.5, fontSize:14}}>{t.message}</div>
        </div>
      ))}
      <style>{`
        @keyframes slide-in {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-slide-in {
          animation: slide-in 0.3s ease-out;
        }
      `}</style>
    </div>
  );
}

